import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MaterialSwitch from "../../MaterialComponents/MaterialSwitch";
//5889

import { TextField } from "formik-mui";
// 5888
import { Field, useFormikContext } from "formik";
import BrandAutoComplete from "../../MaterialComponents/BrandAutoComplete";
import MoreInfo from "../../MaterialComponents/MoreInfo";
// import { VKPost } from "@lumen-developer/lumen-lookalikes/dist/Previews";
import Divider from "@mui/material/Divider";
import validator from "validator";
import propTypes from "prop-types";

export default function VKStandard({ brandTypes }) {
  const { values } = useFormikContext();

  function VKStandardValidationSchema(value, name) {
    let error;
    if (name === "stim_url") {
      if (!value) {
        error = "Required";
      } else if (!validator.isURL(value)) {
        error = "Must be a valid URL";
      } else if (value.length > 512) {
        error = "Too long";
      }
    }
    if (name === "fb_channel_name") {
      if (!value) {
        error = "Required";
      } else if (value.length > 50) {
        error = "Too long";
      }
    }
    if (name === "fb_profile_src") {
      if (!value) {
        error = "Required";
      } else if (!validator.isURL(value)) {
        error = "Must be a valid URL";
      } else if (value.length > 511) {
        error = "Too long";
      }
    }
    if (name === "fb_description") {
      if (!value) {
        error = "Required";
      } else if (value.length > 511) {
        error = "Too long";
      }
    }
    return error;
  }

  return (
    <>
      <Divider variant="middle" />

      <Grid
        style={{ margin: "24px 0px 12px" }}
        container
        wrap="nowrap"
        justifyContent="center"
        item
        xs={12}
      >
        <Typography align="center" variant="h6" component={"span"}>
          VK news feed
        </Typography>
      </Grid>

      <div
  style={{
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
  }}
>
        <div style={{ height: "100%", width: "50%", padding: 16 }}>
          {/* <VKPost
            lang_code={values.language.code.toUpperCase()}
            vk_profile_src={values.fb_profile_src}
            vk_stim_profile={values.fb_channel_name}
            vk_description={values.fb_description}
            stim_url={values.stim_url}
          /> */}
        </div>
        <div
          style={{
            overflowY: "scroll",
            height: "100%",
            width: "100%",
            position: "absolute",
            right: 0,
            top: 0,
            padding: 16,
          }}
        >
          <Grid style={{ width: "100%" }} container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" component={"span"}>
                Please enter the ad URL and choose the brand name
              </Typography>
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="stim_url"
                component={TextField}
                label="Ad URL"
                variant="filled"
                validate={(value) =>
                  VKStandardValidationSchema(value, "stim_url")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="A link to a webpage only featuring the test ad"
              />
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <BrandAutoComplete brandTypes={brandTypes} />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The brand name of the company featured in the test ad "
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" component={"span"}>
                Now customize the post
              </Typography>
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_profile_src"
                component={TextField}
                label="Profile photo URL"
                variant="filled"
                validate={(value) =>
                  VKStandardValidationSchema(value, "fb_profile_src")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="A link to a webpage only featuring the profile photo"
              />
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_channel_name"
                component={TextField}
                label="Profile name"
                variant="filled"
                validate={(value) =>
                  VKStandardValidationSchema(value, "fb_channel_name")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The profile name as you would like it to appear"
              />
            </Grid>
            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_description"
                component={TextField}
                label="Description"
                multiline
                variant="filled"
                validate={(value) =>
                  VKStandardValidationSchema(value, "fb_description")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The text appearing above the image or video"
              />
            </Grid>

            {values.stim_url.split(".")[
              values.stim_url.split(".").length - 1
            ] === "mp4" ? (
              <Grid container wrap="nowrap" item xs={12}>
                <Grid item xs={12}>
                  <MaterialSwitch
                    label="Play sound automatically?"
                    name="has_sound"
                  />
                </Grid>
                <MoreInfo
                  outerContainerClassName="moreInfo"
                  popup="This will start sound playing as soon as the video starts"
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </div>
      </div>
      <Grid item xs={12}>
        <Divider variant="middle" />
      </Grid>
    </>
  );
}

VKStandard.propTypes = {
  brandTypes: propTypes.object,
};
